import React from "react";
import { MatchingDesk } from "../../../../api/grpc/desk/desk";
import { BookingsSearchHeader } from "../BookingsSearchHeader/BookingsSearchHeader";
import { BookingsDesksTable } from "../BookingsSearchTable/BookingsDesksTable";
import { SearchDesk } from "../../../../api/grpc/workplaces/workplaces";

interface Props {
  desks: MatchingDesk[] | null;
  assignedDesk?: SearchDesk;
}

export const BookingsDesksResult = ({ desks, assignedDesk }: Props) => {
  return (
    <>
      {desks && desks?.length > 0 ? (
        <div>
          <BookingsSearchHeader type="desk" />
          <BookingsDesksTable desks={desks} assignedDesk={assignedDesk} />
        </div>
      ) : (
        <div>No results...</div>
      )}
    </>
  );
};
